// 遇到這些錯誤時 直接登出
export const API_LOGOUT_ERRORS = [-101, -102, -105];
